// extracted by mini-css-extract-plugin
export var completionBody = "_m2-2";
export var completionCard = "_m2-0";
export var completionFooter = "_m2-3";
export var completionTitle = "_m2-1";